import React from "react";
import { Alert } from "reactstrap";

export default () => (
  <Alert color="danger">
    <h3>Jeszcze niewdrożone</h3>
  </Alert>
);
